import styles from './index.module.scss';
import {Dropdown, message} from 'antd';
import {LoginOutlined, SettingOutlined} from '@ant-design/icons';
import {errorMessage, goLogin} from 'Utils/common';
import useStorage from '../../../../../Utils/Hooks/useStorage';
import useModalHandler from '../../../../../Utils/Hooks/useModalHandler';
import {EditPassModal} from '../EditPassModal';
import React from 'react';

export default function UserInfo() {
    const passModal = useModalHandler({component: EditPassModal});
    const [loginName] = useStorage('loginName', '');

    async function onLogout() {
        try {
            await goLogin();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const menu = [
        {
            key: 1,
            label: '修改密码',
            icon: <SettingOutlined />,
            className: styles.menuItem,
            onClick: () => passModal.open({onOk: passModal.close}),
        },
        {
            key: 2,
            label: '安全退出',
            icon: <LoginOutlined />,
            className: styles.menuItem,
            onClick: onLogout,
        },
    ];

    return (
        <React.Fragment>
            <Dropdown
                className={styles.root}
                overlayClassName={styles.dropdown}
                menu={{items: menu}}
                placement="bottom"
                arrow>
                <span>{loginName}</span>
            </Dropdown>

            {passModal.render()}
        </React.Fragment>
    );
}
